<template>
  <div class="itemCont" @click="goodsChecked(item)">
    <div class="itemImg">
      <el-image
        lazy
        :src="item.image || avater"
        alt=""
        style="width: 140px; height: 140px; padding: 15px 0px"
      />
      <i :class="isChcked ? 'el-icon-success' : 'el-icon-circle-check'"></i>
    </div>

    <el-tooltip
      class="item"
      effect="dark"
      :content="item.goodsSkuTitle"
      placement="top"
    >
      <div class="itemBox name">
        {{ item.goodsSkuTitle || "" }}
      </div>
    </el-tooltip>
    <div class="itemBox factory">{{ item.factory || "" }}</div>
    <div class="itemBox factory">
      {{ item.specification || "" }}
    </div>
    <el-tooltip
      class="item"
      effect="dark"
      :content="item.skuId"
      placement="top"
    >
      <div class="itemBox factory">SKU：{{ item.skuId || "" }}</div>
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="item.shopName"
      placement="top"
    >
      <div class="itemBox factory" v-if="item.shopName">
        {{ item.shopName }}
      </div>
    </el-tooltip>
    <p class="itemBox factory" v-if="item.salePrice">¥{{ item.salePrice }}</p>
  </div>
</template>
<script>
import avater from "/public/img/default.png";
import _ from "lodash";
export default {
  props: {
    passedItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    chooseGoods: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      avater: avater,
      form: {},
    };
  },
  computed: {
    isChcked() {
      return this.chooseGoods.find(
        (item) => item.skuId === this.passedItem.skuId
      );
    },
    item() {
      const val = _.cloneDeep(this.passedItem);
      val.isChcked = this.isChcked;
      return val;
    },
  },
  methods: {
    goodsChecked(item) {
      item.isChcked = !item.isChcked;
      this.$emit("checkedGoodItem", item);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.itemCont {
  width: 180px;
  height: 300px;
  border: 1px solid #ccc;
  margin: 0 8px 8px 0;
  border-radius: 4px;

  &:hover {
    border: 2px solid;
    border-color: $borderColorActive;
  }

  .factory {
    color: #595959;
    font-size: 14px;
    height: 22px;
  }

  .itemBox {
    padding: 0px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 22px;
    margin: 0;
  }

  .name {
    display: block !important;
    font-size: 16px;
    font-weight: 600;
    padding: 4px 10px;
  }

  .itemImg {
    position: relative;
    height: 140px;
    width: 100%;
    display: flex;
    justify-content: center;
    .el-icon-success,
    .el-icon-circle-check {
      position: absolute;
      top: 6px;
      right: 6px;
      font-size: 30px;
    }
    .el-icon-success {
      color: red;
    }

    .el-icon-circle-check {
      color: #f3f3f2;
      &:hover {
        color: red;
      }
    }
  }

  .price {
    font-weight: 700;
    justify-content: end;
  }
}

::v-deep .el-button {
  span {
    margin-left: 0px !important;
  }
}
</style>
